import React from 'react';

const ArrowButton = ({ arrowClass }) => (
  <div className={arrowClass}>
    <span />
  </div>
);

export default ArrowButton;
